import React, { useCallback } from "react";

import { formatPrice } from "@app/scripts/utils";
import { Button } from "@app/scripts/react-general-components/Button";

import type { Cart } from "@app/scripts/types";

type Props = {
  cart: Cart | null;
  totalDiscount: string | null;
  goToCheckout: (e: any) => Promise<void>;
  additionalCheckout?: string | null;
  cartTotal: number;
  toggleOpen?: (e?: React.MouseEvent<HTMLElement, MouseEvent>, _open?: boolean) => void;
  view?: "cart_page";
  cartBeforeDiscountPrice: string;
};

export const CartOrderSummary: React.FC<Props> = ({
  totalDiscount,
  cart,
  goToCheckout,
  additionalCheckout,
  cartTotal,
  toggleOpen,
  view,
  cartBeforeDiscountPrice,
}) => {
  const handleContinueShopClick = useCallback(
    () => (view === "cart_page" ? (window.location.href = "/") : toggleOpen?.()),
    [toggleOpen, view]
  );

  console.log(typeof cartBeforeDiscountPrice);

  return (
    <div className="cart__order-summary text-dark-grey">
      <h2 className="cart__order-summary__title h4 uppercase">Order Summary</h2>

      <div className="cart__order-summary__details">
        <div className={`${additionalCheckout ? "mb-4" : "mb-2"} cart__discount`}>
          <span className="text-md">Subtotal</span>
          <span className="text-md">{cartBeforeDiscountPrice}</span>
        </div>
        {totalDiscount && (
          <div className={`${additionalCheckout ? "mb-4" : "mb-2"} cart__discount`}>
            <span className="text-md">Discounts</span>
            <span className="text-md">-{totalDiscount}</span>
          </div>
        )}
        <div className={`${additionalCheckout ? "mb-4" : "mb-2"} cart__total uppercase`}>
          <span className="h3 bold">Total</span>
          <span className="h3 bold">{cart && formatPrice(cartTotal)}</span>
        </div>
        <p className="text-sm text-neutral-secondary-grey cart__shipping">
          Shipping, Gift Cards & Promo Codes calculated at checkout.
        </p>
        <div className="cart__checkout">
          <Button
            onClick={goToCheckout}
            label="Checkout"
            variant={additionalCheckout ? "primary" : "secondary"}
            className="fullwidth"
          />

          {additionalCheckout ? (
            <div className="cart__express-checkout">
              <h3 className="cart__express-checkout-title">Express Checkout</h3>
              <p className="text-sm text-neutral-secondary-grey cart__express-checkout__shipping">
                Gift Cards and promo codes cannot be applied when using express checkout
              </p>
              <div dangerouslySetInnerHTML={{ __html: additionalCheckout }} />
            </div>
          ) : null}

          <Button
            onClick={handleContinueShopClick}
            ariaLabel="Continue Shopping"
            label="Continue Shopping"
            variant="text"
          />
        </div>
      </div>
    </div>
  );
};
